import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { immigrateQuestionsAPI } from 'features/immigrate-question/api'
import {
  IMMIGRATE_QUESTION_CREATE_REQUEST,
  IMMIGRATE_QUESTION_CREATE_SUCCESS,
  IMMIGRATE_QUESTION_CREATE_FAILED,
} from './actionTypes'

export const immigrateQuestionCreatePA = createPromiseAction(
  IMMIGRATE_QUESTION_CREATE_REQUEST,
  IMMIGRATE_QUESTION_CREATE_SUCCESS,
  IMMIGRATE_QUESTION_CREATE_FAILED
)()

function* create(action) {
  try {
    const { params } = action.payload

    const response = yield call(immigrateQuestionsAPI.createQuestion, params)
    const { data } = response

    yield put(immigrateQuestionCreatePA.success({}))

    resolvePromiseAction(action, { ...data.data })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* createSaga() {
  yield takeEvery(immigrateQuestionCreatePA.request, create)
}
